
import React from "react";
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import axios from 'axios'

import Myaccount from "../Components/Myaccount/Myaccount";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import { generateApiKey } from "../helpers/common.helpers";
const apiKey = generateApiKey();
const AuthMyaccount = () => {
  let navigate = useNavigate();
  useEffect(()=>{
    const fetchToken=async()=>{
      const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');
if (token) {
  console.log(token, "auth my account token");
  const options = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      authorization: token,
      "page-index": generateApiKey(),
    },
  };
  const sendData = {
  }
 await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT_NODE_PRODUCTION_DASHBOARD}/verifyToken/token`,sendData,
        options,
        { withCredentials: true }
      )
      .then((result) => {
        if (result.data.status == 200) {
          const user_data = result.data.data;
          
          // Set common user data regardless of enrollment count
          if (user_data.user_id) window.localStorage.setItem("user_id", user_data.user_id);
          if (user_data.firstname) window.localStorage.setItem("username", user_data.firstname);
          if (user_data.userlastname) window.localStorage.setItem("lastname", user_data.userlastname);
          if (user_data.email) window.localStorage.setItem("email", user_data.email);
          window.localStorage.setItem("mobile", user_data.mobile);
          window.localStorage.setItem("dob", user_data.dob);
          window.localStorage.setItem("batch_id", user_data.batch_id);
          window.localStorage.setItem("term", user_data.term);
          window.localStorage.setItem("count", user_data.count);

          if (user_data.count == "1") {
            window.localStorage.setItem("enrol_id", user_data.enrol_id);
            window.localStorage.setItem("category", user_data.category);
            window.localStorage.setItem("user_role", user_data.user_role);
            window.localStorage.setItem("program_id", user_data.program_id);
            navigate(`/Dashboard`);
          } else if (user_data.count == "2" || user_data.count == "3") {
             console.log(user_data.count, "enrol count")
             // Additional fields or navigation for count 2/3 can go here if needed
          }
        }
        else{
          // console.log(result.data.messaage)
          alert(result.data.messaage)
          localStorage.clear()
        }
      });
} else {
  localStorage.clear();
}
    }
    fetchToken()

  },[])
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Myaccount /> : <SessionTimeoutRedirect />;
}
export default AuthMyaccount;


